import { useMediaQuery, Theme } from '@material-ui/core';
import { getBrowserDetails } from '../utils/helpers';
import breakpoints from '../theme/material/breakpoints';

const useMediaBreakpoints = (): {
  isWideDesktop: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  isTabletMobileOnly: boolean;
  isTabletUp: boolean;
  isMobile: boolean;
  isMobileXs: boolean;
  isMobileViewPort: boolean;
} => {
  const browserDetails = getBrowserDetails();
  const isMobileBrowser = browserDetails.isMobile;

  const isWideDesktop = useMediaQuery<Theme>(() => breakpoints.up('lg'));
  const isDesktop = useMediaQuery<Theme>(() => breakpoints.up('md'));
  const isTablet = useMediaQuery<Theme>(() => breakpoints.down('md'));
  const isTabletMobileOnly = useMediaQuery<Theme>(() => breakpoints.between('sm', 'lg'));
  const isTabletUp = useMediaQuery<Theme>(() => breakpoints.up('sm'));
  const isMobileMediaQuery = useMediaQuery<Theme>(() => breakpoints.down('sm'));
  const isMobileXs = useMediaQuery<Theme>(() => breakpoints.down('xs'));

  const isMobileViewPortQuery = useMediaQuery<Theme>(() => breakpoints.between(768, 820));

  const isMobile = isMobileBrowser || isMobileMediaQuery;
  // this is similar from IsMobileViewPort in src/utils/helpers.ts
  const isMobileViewPort = isMobile && !isMobileViewPortQuery;

  return {
    isWideDesktop,
    isDesktop,
    isTabletMobileOnly,
    isTabletUp,
    isTablet,
    isMobile,
    isMobileXs,
    isMobileViewPort,
  };
};

export default useMediaBreakpoints;
